import { FC } from 'react';
import serverVars from 'server-vars';

import { FormattedMessage } from 'dibs-react-intl';
import HeadingLevel from 'dibs-controlled-heading/exports/HeadingLevel';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import IFramedPromoPartnershipPCForm from './IFramedPromoPartnershipPCForm';
import IFramedPromoPartnershipStartShoppingCta from './IFramedPromoPartnershipStartShoppingCta';

import { ReducerState, DispatchType } from './reducer';

import styles from './styles/IFramedPromoPartnershipPromoCode.scss';
import sharedStyles from './styles/shared.scss';

const showPrivateClientForm = serverVars.get('privateClientForm') === 'TRUE';

type Props = {
    state: ReducerState;
    dispatch: DispatchType;
};

const IFramedPromoPartnershipPromoCode: FC<Props> = ({ state, dispatch }) => {
    const { promoCode, isLoading } = state;

    return (
        <HeadingLevel>
            {Heading => (
                <div className={sharedStyles.wrapper}>
                    <div className={sharedStyles.header}>
                        <BarHeader
                            htmlElementType={Heading}
                            title={
                                <FormattedMessage
                                    id="iFramedpromoPartnership.IFramedPromoPartnershipPromoCode.title"
                                    defaultMessage="Promo Code: {promoCode}"
                                    values={{
                                        promoCode: (
                                            <span className={styles.promoCode}>{promoCode}</span>
                                        ),
                                    }}
                                />
                            }
                            subtitle={
                                showPrivateClientForm && (
                                    <FormattedMessage
                                        id="iFramedpromoPartnership.IFramedPromoPartnershipPromoCode.subtitle"
                                        defaultMessage="If you require a Private Client Consultation please submit the form below."
                                    />
                                )
                            }
                        />
                    </div>
                    {showPrivateClientForm && (
                        <IFramedPromoPartnershipPCForm state={state} dispatch={dispatch} />
                    )}
                    <IFramedPromoPartnershipStartShoppingCta
                        type={showPrivateClientForm ? 'transparent' : 'primary'}
                        fullWidth={showPrivateClientForm}
                        disabled={isLoading}
                    />
                </div>
            )}
        </HeadingLevel>
    );
};

export default IFramedPromoPartnershipPromoCode;
